import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeywordData } from '../classes/keywordData';
import { HttpService } from './http.service';
import { environment } from '../environment';
@Injectable({
    providedIn: 'root'
})
export class CalculateClusterService {
    calculateCluster(data: any, similarity: string,settings:any) {
        data = JSON.stringify(data);
        data = JSON.parse(data);
        let iterateClusterData = data;
        let clusteredData: any = []
        return new Promise((resolve, reject) => {
            data.forEach((e: any) => {
                if(!e["isClustered"]){
                    let clusterArray: any = [];
                    let clustureVolume = 0;
                    let weakSpotCount = 0;
                    let weakKeyword = 0;

                    data.forEach((el: any, index: any) => {
                        if (!el.isClustered) {
                        let similarCount = 0
                        if (el.data) {
                            el.data[0][el.title].forEach((position: any) => {
                                if (e.data && e.data[0][e.title].map((k: any) => { return k.link }).includes(position.link)) {
                                    similarCount++
                                }
                            })
                            if (similarCount >= Number(similarity)) {
                                clustureVolume += Number(el.vol) > 0 ? Number(el.vol) : 0;
                                el.keywordPosition.forEach((ele:any)=>{
                                    ele.serp.serp.forEach((element:any) => {
                                        let checkCustomdomain = settings.customDomain?.includes(ele.serp.domain);
                                        if(element?.key){
                                            weakSpotCount = weakSpotCount + 1;
                                            if (element?.key == 'web 2.0' || element?.key == 'socialmedia' || element?.key == 'filetype') {
                                                weakSpotCount = weakSpotCount - 1;
                                              }
                                              if (checkCustomdomain) {
                                                weakSpotCount = weakSpotCount + 1;
                                              }
                                            if (element?.key === "lowda" && element?.da?.da > settings.maxDa) {
                                                weakSpotCount = weakSpotCount - 1;
                                            }
                                        }
                                       
                                    });
                                })
                                if(el.weakSpotCount >=1){
                                    weakKeyword = weakKeyword + 1;
                                }
                                // weakSpotCount += el.weakSpotCount;
                                el["isClustered"] = true;
                                clusterArray.push(el)
                            }
                        }
                    }
                    });
                    if (clusterArray && clusterArray.length > 1) {
                        clusterArray = clusterArray.sort((a: any, b: any) => {
                            return b.vol - a.vol;
                        });
                        e["cluster"] = clusterArray;
                        if (clusterArray.length > 0) {
                            e["HighestVolKey"] = clusterArray[0];
                        } else {
                            e["HighestVolKey"] = [];
                        }
                        e["clusterVol"] = clustureVolume;
                        e["clusterWeakSpotCount"] = weakKeyword;
                        e["page"] = 1;
                        e["totalCount"] = clusterArray.length
                        e['paginateData'] =  clusterArray.slice((e.page - 1) * 10, (e.page - 1) * 10 + 10);

                        e['cpcUparrow'] = false;
                        e['cpcDownarrow'] = false;
                        e['volUparrow'] = false;
                        e['volDownarrow'] = false;
                        e['serpUpArrow'] = false;
                        e['serpDownArrow'] = false;
                        e['weakSpotUpArrow'] = false;
                        e['weakSpotDownArrow'] = false;

                        clusteredData.push(e);
                    }
                }
            });
            resolve(clusteredData);
        })
    }
}